/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserUpdateRequest
 */
export interface UserUpdateRequest {
    /**
     * email of the user
     * @type {string}
     * @memberof UserUpdateRequest
     */
    email?: string;
    /**
     * optional users first name
     * @type {string}
     * @memberof UserUpdateRequest
     */
    firstname?: string;
    /**
     * optional users last name
     * @type {string}
     * @memberof UserUpdateRequest
     */
    lastname?: string;
}

/**
 * Check if a given object implements the UserUpdateRequest interface.
 */
export function instanceOfUserUpdateRequest(value: object): value is UserUpdateRequest {
    return true;
}

export function UserUpdateRequestFromJSON(json: any): UserUpdateRequest {
    return UserUpdateRequestFromJSONTyped(json, false);
}

export function UserUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
    };
}

export function UserUpdateRequestToJSON(json: any): UserUpdateRequest {
    return UserUpdateRequestToJSONTyped(json, false);
}

export function UserUpdateRequestToJSONTyped(value?: UserUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
    };
}

